// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1___ccaae1042fab9652e25{/*!*/}.CoreXNav-cls2__fe61a6135d2d619b7671{display:flex;align-items:center;grid-gap:24px;gap:24px}.CoreXNav-cls2__fe61a6135d2d619b7671>*{margin:0;white-space:nowrap}.CoreXNav-cls2__fe61a6135d2d619b7671>*>*{white-space:normal;white-space:initial}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1___ccaae1042fab9652e25",
	"cls2": "CoreXNav-cls2__fe61a6135d2d619b7671 CoreXNav-cls1___ccaae1042fab9652e25"
};
export default ___CSS_LOADER_EXPORT___;
